'use strict';

const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

exports.isBezierDefinition = isBezierDefinition;
//# sourceMappingURL=is-bezier-definition.cjs.map
